import axios from 'axios'
import convert from 'xml-js'

export const loginSuccess = (user) => ({
  type: 'LOGIN',
  user
})

export const loginError = () => ({
  type: 'LOGIN_ERROR'
})

/* export const loginBackend = (backend, appName, username, password) => {
  return(dispatch) => {
    return axios.post(`${backend}${appName}login?username=${encodeURI(username)}&password=${encodeURI(password)}`)
    .then((response) => {
      const login: any = convert.xml2js(response.data, {
        compact: true,
        alwaysArray: true
        })
        console.log(login.login[0].success[0]._text[0])
        if(login.login[0].success[0]._text[0] === "true"){
            dispatch(login({loggedIn: true, username: username, password: password}))
        } else {
          dispatch(loginError())
        }
      
    })
  }
} */

export const login = (backend, appName, username, password) => {
  return(dispatch) => {
    return axios.post(`${backend}${appName}login`, null, {params:{
      username: username,
      password: password
    }})
    .then((response) => {
      const login: any = convert.xml2js(response.data, {
        compact: true,
        alwaysArray: true
        })
        const permissions = []
        if(login.login[0].permissions){
          if(login.login[0].permissions[0].permission){
            login.login[0].permissions[0].permission.map(permission => {
              permissions.push(permission._text[0])
            })
          }

        }
        if(login.login[0].success[0]._text[0] === "true"){
            dispatch(loginSuccess({loggedIn: true, username: username, password: password, permissions: permissions}))
        } else {
          dispatch(loginError())
        }
      
    })
    .catch(error => {
      console.error('error', error)
      dispatch(loginError())
    })
  }
}

export const ssoLoadUser = (backend, appName) => {
  return(dispatch) => {

    axios.get(`${backend}${appName}sso/userinfo`, { withCredentials: true })
        .then(response => {

            const permissions = response.data.permissions? response.data.permissions : []
            dispatch(loginSuccess({loggedIn: true, username: response.data.preferred_username, password: "", permissions: permissions}))
          }
        )
    .catch(error => {
      dispatch(loginError())
    })
  }
}

export const logout = (backend, appName, isSso, rediretUri) => {

  return(dispatch) => {

    if(!isSso) {

      dispatch({
              type: 'LOGOUT'
      });

    } else {

      axios.get(`${backend}${appName}sso/logout`, { 

          withCredentials: true })
          .then(response => {

            dispatch({
              type: 'LOGOUT'
            });

            if(rediretUri) {
              window.location.replace(rediretUri);
            }
            }
          )
      .catch(error => {
        console.error('error', error)
      })
    }
  }
}
